export default __webpack_public_path__ + "images/3K.581ad79.png";